import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../AppContext";

const PlayBackDataQualityCircle = ({
  timeStamp,
  enabled,
  interval,
  parameterName,
  currentPlayTime,
}) => {
  const { t } = useTranslation();
  const { getTimeZoneDateTime } = useContext(AppContext);
  const [status, setStatus] = useState("critical");

  const CalcTimeDiff = (currentTime, localLastSensorTime) => {
    const sixXT = 6 * (interval * 1000);
    const tenXT = 10 * (interval * 1000);
    const timeDiff = Math.max(0, currentTime - localLastSensorTime);
    if (timeDiff > tenXT) {
      setStatus("critical");
    } else if (timeDiff > sixXT) {
      setStatus("warning");
      const criticalTimeout = setTimeout(() => {
        setStatus("critical");
      }, tenXT - timeDiff);
      return () => {
        // Clear the timeouts when the component is unmounted or when status changes
        clearTimeout(criticalTimeout);
      };
    } else {
      setStatus("normal");
      const warningTimeout = setTimeout(() => {
        setStatus("warning");
      }, sixXT - timeDiff); // 1 minute in milliseconds

      // Set status to critical after 2 minutes
      const criticalTimeout = setTimeout(() => {
        setStatus("critical");
      }, tenXT - timeDiff);
      return () => {
        // Clear the timeouts when the component is unmounted or when status changes
        clearTimeout(warningTimeout);
        clearTimeout(criticalTimeout);
      };
    }
  };

  useEffect(() => {
    if (timeStamp && currentPlayTime) {
      const localLastSensorTime = getTimeZoneDateTime(timeStamp); // Convert lastSensorTime to local time zone
      const currentTime = getTimeZoneDateTime(currentPlayTime);
      CalcTimeDiff(currentTime, localLastSensorTime);
    }
  }, [currentPlayTime]);

  return (
    <TooltipComponent
      key={parameterName}
      content={
        enabled && timeStamp
          ? status && t(`dataQualityCircle.${status}`)
          : t(`dataQualityCircle.critical`)
      }
    >
      <div className="">
        <div
          className={`${
            enabled && timeStamp && status
              ? `bg-gradient-to-tr ${
                  status === "normal"
                    ? "from-green-500 to-green-700 shadow-green-700"
                    : status === "critical"
                    ? "from-red-500 to-red-700 shadow-red-700"
                    : status === "warning"
                    ? "from-amber-500 to-amber-700 shadow-amber-700"
                    : ""
                } top-2 left-1`
              : "bg-gradient-to-tr from-red-500 to-red-700 shadow-red-700"
          } h-3 w-3 rounded-full shadow-sm`}
        ></div>
      </div>
    </TooltipComponent>
  );
};

export default PlayBackDataQualityCircle;
